module.exports = __webpack_public_path__ + "static/img/revatech-new-logo.5ebb22f3.png";